import { render, staticRenderFns } from "./MyBookingsView.vue?vue&type=template&id=1626f7ed&scoped=true"
import script from "./MyBookingsView.vue?vue&type=script&lang=js"
export * from "./MyBookingsView.vue?vue&type=script&lang=js"
import style0 from "./MyBookingsView.vue?vue&type=style&index=0&id=1626f7ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1626f7ed",
  null
  
)

export default component.exports